import { makeStyles } from '@eagleview/ev-comp-library';

export const useStyles = makeStyles((theme) => ({
  labelContainer: {
    top: theme.spacing(0),
    left: theme.spacing(0),
    bottom: theme.spacing(0),
    right: theme.spacing(0),
    position: 'absolute',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  container: {
    position: 'relative',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
  },
  msgStyle: {
    fontSize: theme.spacing(3),
    lineHeight: '34px',
    color: theme.evPalette.salt[500],
  },
  autoProvisionBox: {
    justifyContent: 'center',
    marginRight: 'auto',
    marginLeft: 'auto',
    marginTop: '40vh',
  },
  autoProvisionMsg: { textAlign: 'center', marginTop: theme.spacing(3) },
}));

export default useStyles;
